import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { createCompleteCampaign } from "../../../redux/actions/free/homeActions";
import { toAbsoluteUrl } from "../../../services";
import ROUTES from "../../constants/routes";
import { Button } from "../../../components";
import { useNavigate } from "react-router-dom";
import HelpButton from "../../../components/button/helpButton";


// get step data from redux main state
const data = (state) => state.home;

function CreateCampaign(props) {
  let allData = useSelector(data);
  let navigate = useNavigate();
  const [no, setNo] = useState(1);

  // handleVisitDashboard
  let handleVisitDashboard = () => {
    navigate(`${ROUTES.DASHBOARD}`, { replace: true });
  };

  let handleInvite = () => {
    navigate(`${ROUTES.INVITE}`, {
      state: {
        url: allData && allData.bucketName,
        campaignId: allData && allData.campaignId,
      },
    });
  };
  // const { createCompleteCampaign } = props;


  return (
    <div className="2xl:w-6/12 xl:w-7/12 lg:w-7/12 w-11/12 mb-28">
      <div className="bg-white rounded-md shadow-lg mb-20 2xl:px-8 xl:px-8 lg:px-8 px-4 py-8 w-full">
        {allData &&
          allData.bucketName &&
          allData.message == "Game Live Link" ? (
          <div>
            <div className="flex flex-row 2xl:flex-nowrap xl:flex-nowrap lg:flex-nowrap flex-wrap">
              <div>
                <h1 className="2xl:text-2xl xl:text-2xl lg:text-2xl text-2xl  font-bold ">
                  Congratulations! Your Assessment Game has been created.
                </h1>
                <div className="flex flex-col mt-6 font-medium">
                  <div className="mt-5"></div>

                  <button
                    onClick={handleVisitDashboard}
                    className="bg-[#FFD700] text-[#4F4F4F] font-semibold mt-[1rem]  px-6 py-2  text-lg leading-normal capitalize rounded shadow-md  2xl:w-8/12 xl:w-8/12 lg:w-8/12 w-full"
                  >
                    Visit Dashboard
                  </button>

                  <Button
                    type="button"
                    customStyle="2xl:w-8/12 xl:w-8/12 lg:w-8/12 w-full font-semibold  mt-4"
                    name="Send Invites"
                    onClick={handleInvite}
                  />
                </div>
              </div>
              <div>
                <img
                  alt="Logo"
                  src={toAbsoluteUrl("/media/home/campaign_created.png")}
                  style={{ marginTop: "-7px" }}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col justify-center items-center">
            <img
              src={toAbsoluteUrl("/media/dashboard/logo.gif")}
              alt="TTG LOGO"
              style={{
                width: "100px",
                height: "90px",
              }}
            />
            <p className="font-medium text-xl ">
              {allData && allData.message ? allData.message : ""}
            </p>
          </div>
        )}
      </div>
      <HelpButton screen="login" />
    </div>
  );
}

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  createCompleteCampaign,
})(CreateCampaign);
